// TODO
// - add should update check to reduce renders

import { get } from "lodash";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { connect } from "formik";

import SegmentMessage from "../messages/SegmentMessage.jsx";

class FormikAPIErrorMessage extends PureComponent {
  static propTypes = {
    formik: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    apiErrors: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object
  };

  getError() {
    const {
      name,
      formik: { touched, errors },
      apiErrors
    } = this.props;

    const apiError = get(apiErrors, name, null);
    if (apiError) return apiError;

    const touch = get(touched, name, null);
    if (!touch) return null;

    const error = get(errors, name, null);
    if (error) return error;

    return null;
  }

  renderSegmentMessage = error => {
    return <SegmentMessage message={error} negative={true} />;
  };

  renderFieldMessage = error => {
    const { className, style } = this.props;

    const fullClassName = `formik-api-error-message${
      className ? ` ${className}` : ""
    }`;

    return (
      <span className={fullClassName} style={style}>
        {error}
      </span>
    );
  };

  render() {
    const { segment } = this.props;

    const error = this.getError();

    if (error && typeof error === "string") {
      return segment
        ? this.renderSegmentMessage(error)
        : this.renderFieldMessage(error);
    }

    return null;
  }
}

export default connect(FormikAPIErrorMessage);
